// extracted by mini-css-extract-plugin
export default {"box":"SaveValueButton_box__5dAUE","btnContainer":"SaveValueButton_btnContainer__t5cOk"};